module.exports = __webpack_public_path__ + "img/multiplication-and-division-math-magic-tip4.382b9fe3.png";